import { useDispatch } from 'react-redux';

import { Button, Tooltip } from '../../../shared/ui';

import { IconMap } from '../../../shared/sprite';
import { Icon } from '../../../shared/ui';

import { ButtonSquare } from '../../../shared/ui';
import { cn } from '@distribute/frontend/utils';

import { navigate } from '../../../processes/navigation';
import { TEAM_SETTINGS_CALL_RECORDINGS } from '../../../entities/history';

import { useLocalStorage } from '@distribute/frontend/utils';

import { CALL_RECORDING_RIGHT_SIDEBAR_CALENDAR } from '../../../shared/constants';

import { callRecordingsModel } from '../model';

export const CallsHeader = () => {
  const dispatch = useDispatch();

  const [isMeetingEventsSidebarOpen, setIsMeetingEventsSidebarOpen] =
    useLocalStorage(CALL_RECORDING_RIGHT_SIDEBAR_CALENDAR, true);

  const handleNavigateToSettings = () => {
    dispatch(navigate({ to: TEAM_SETTINGS_CALL_RECORDINGS }));
  };

  const handleJoinCallManually = () => {
    dispatch(callRecordingsModel.actions.setIsJoinCallOpenModal(true));
  };

  return (
    <div className="flex items-center justify-between gap-3">
      <h1 className="font-medium text-gray-900 text-display-sm font-display truncate">
        Call recordings
      </h1>
      <div className="md:hidden flex flex-nowrap gap-x-3 items-center">
        <Tooltip
          trigger={
            <ButtonSquare
              size="md"
              onClick={handleNavigateToSettings}
              variant="secondary-gray"
            >
              <Icon glyph={IconMap.Settings} width={20} />
            </ButtonSquare>
          }
          hideArrow
          className="font-semibold px-3 py-2"
          sideOffset={4}
        >
          Settings
        </Tooltip>
        <Button
          size="md"
          variant="text"
          color="primary"
          iconLeftName={IconMap.VideoRecorder}
          iconLeftWidth={20}
          iconBlockClassName="mr-1"
          onClick={handleJoinCallManually}
          className="!font-semibold"
        >
          Join call
        </Button>
        <Tooltip
          trigger={
            <ButtonSquare
              size="md"
              onClick={() =>
                setIsMeetingEventsSidebarOpen(!isMeetingEventsSidebarOpen)
              }
              variant="secondary-gray"
              className="lg:hidden"
            >
              <Icon
                glyph={IconMap.CloseCalendar}
                width={20}
                className={cn({
                  'rotate-180': !isMeetingEventsSidebarOpen,
                })}
              />
            </ButtonSquare>
          }
          hideArrow
          className="font-semibold px-3 py-2"
          sideOffset={4}
        >
          {isMeetingEventsSidebarOpen ? 'Hide calendar' : 'Show calendar'}
        </Tooltip>
      </div>
    </div>
  );
};
